import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Icon,
  Snackbar,
  Typography,
  Button,
  Divider,
  // TextField,
  Stepper,
  Step,
  StepLabel,
  Stack,
  // CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
  MenuItem,
  FormControl,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useGeolocated } from "react-geolocated";
import QRCode from "react-qr-code";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";
import FormSectionBuilder from "../../components/data_forms/form_section_builder";
import usePageTitle from "../../pageTitle";
import { useNavigate, useParams } from "react-router-dom";

function CheckoutPage() {
  const pageTitle = "Checkout";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(stringtext) {
    console.log(stringtext);
    try {
      await navigator.clipboard.writeText(stringtext);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  const [steps, setSteps] = useState(["Payment Information", "Process Order"]);

  const [activeStep, setActiveStep] = useState(0);
  const [cartReference, setCartReference] = useState(null);
  const [products, setProducts] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0.0);
  const [currency, setCurrency] = useState(null);

  const [dataForm, setDataForm] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);
  const [dataFormValues, setDataFormValues] = useState(null);

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const [paymentMethod, setPaymentMethod] = useState(null);
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [campaignPaymentMethods, setCampaignPaymentMethods] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`webstore/carts/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCartReference(result.data.data.cart.reference);
            let tPrice = 0;
            result.data.data.cart.products.every((prd) => {
              tPrice += prd.amount * prd.quantity;
              return true;
            });

            setTotalPrice(tPrice);
            setCurrency(result.data.data.cart.currency);
            setProducts(result.data.data.cart.products);

            setDataForm(result.data.data.cart.data_form);
            if (result.data.data.cart.payment_required) {
              setCampaignPaymentMethods(result.data.data.cart.payment_methods);
              setShowPaymentMethods(true);
            } else {
              setShowPaymentMethods(false);
              setPaymentMethod("FREE");
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    const sections = [];
    if (dataForm === null) {
      return;
    }

    dataForm.form.sections.every(async (param) => {
      // console.log(param);
      const sect = <FormSectionBuilder section={param} />;
      sections.push(sect);
      return false;
    });
    // console.log(sections);
    setDataFormSections(sections);
    var stepsTemp = steps;
    setSteps(["Required Information", ...stepsTemp]);
  }, [dataForm]);

  function validateDataForm() {
    const dForm = document.querySelector(`#dataForm`);
    const data = new FormData(dForm);

    for (const entry of data.entries()) {
      if (entry[1].length <= 0) {
        setSeverity("error");
        setErrMsg(
          `${entry[0].charAt(0).toUpperCase()}${entry[0]
            .slice(1)
            .replace(/_/g, " ")}  is required`,
        );
        setOpen(true);
        return false;
      }
    }

    const values = Object.fromEntries(data.entries());
    // const postJson = JSON.stringify(values);
    setDataFormValues({
      reference: dataForm.reference,
      data: values,
    });
    return values;
  }

  const handleNext = () => {
    if (dataForm !== null && activeStep === 0) {
      const validated = validateDataForm();
      if (!validated) {
        return;
      }

      setActiveStep(activeStep + 1);
    } else if ((activeStep === 0 && dataForm === null) || activeStep === 1) {
      dispense();
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  function getStepContent(activeStep) {
    if (activeStep === 0) {
      if (dataForm !== null) {
        return (
          <Box mb={5}>
            <form id="dataForm">
              {dataFormSections.map((section) => (
                <Box mb={5}>{section}</Box>
              ))}
            </form>
          </Box>
        );
      } else {
        return showPayerInformationForm();
      }
    }
    if (activeStep === 1 && dataForm !== null) {
      return showPayerInformationForm();
    }
  }

  function showPayerInformationForm() {
    return (
      <Box mb={5}>
        <Box>
          <Typography variant="caption" fontWeight="regular">
            PAYER INFORMATION
          </Typography>
          <Box mt={2} mb={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  name="last_name"
                  margin="dense"
                  label="Last Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setLastName(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon>person</Icon>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  name="first_name"
                  margin="dense"
                  label="First Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setFirstName(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon>person</Icon>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box mb={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  name="email_address"
                  margin="dense"
                  label="Email Address"
                  type="email"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setEmailAddress(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon>email</Icon>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  name="phone_number"
                  margin="dense"
                  label="Phone Number"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon>phone</Icon>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
        {showPaymentMethods ? (
          <Box mt={5}>
            <Typography variant="caption" fontWeight="regular">
              PAYMENT METHOD
            </Typography>
            <Box mt={3}>
              <TextField
                fullWidth
                select
                label="How do you want to pay?"
                onChange={(e) => {
                  setPaymentMethod(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon>payment</Icon>
                    </InputAdornment>
                  ),
                }}
              >
                {
                  // --> Notice below changes
                  campaignPaymentMethods.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                    campaignPaymentMethods.map((record) => (
                      <MenuItem key={record.value} value={record.value}>
                        {record.name}
                      </MenuItem>
                    ))
                }
              </TextField>
            </Box>
          </Box>
        ) : (
          <> </>
        )}
      </Box>
    );
  }

  async function dispense() {
    const gpsCoords = getGPSCoords();
    // console.log(gpsCoords);
    // if (!gpsCoords) {
    //   setSeverity("error");
    //   setErrMsg("Please enable and allow browser's location and GPS access.");
    //   setOpen(true);
    //   return;
    // }

    if (lastName === null) {
      setSeverity("error");
      setErrMsg("Payer last name required");
      setOpen(true);
      return;
    }

    if (firstName === null) {
      setSeverity("error");
      setErrMsg("Payer first name required");
      setOpen(true);
      return;
    }

    if (emailAddress === null) {
      setSeverity("error");
      setErrMsg("Payer email address required");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Payer phone number required");
      setOpen(true);
      return;
    }

    if (dataForm !== null && dataFormValues === null) {
      setSeverity("error");
      setErrMsg("Required information not filled out properly.");
      setOpen(true);
      return;
    }

    if (paymentMethod === null) {
      setSeverity("error");
      setErrMsg("Payment method required.");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    const json = {
      cart: cartReference,
      payment_method: paymentMethod,
      customer: {
        first_name: firstName,
        last_name: lastName,
        email_address: emailAddress,
        phone_number: phoneNumber,
      },
      latitude: gpsCoords ? gpsCoords.latitude : null,
      longitude: gpsCoords ? gpsCoords.longitude : null,
      data_form: dataForm !== null ? dataFormValues : null,
    };

    console.log(json);

    await axios
      .post("webstore/carts/checkout.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // setSellResult(result.data.data.result);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={10}>
        <Container>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: "100%" }}
            >
              {errorMsg}
            </Alert>
          </Snackbar>
          <Box>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                lg={4}
                sx={{
                  display: { xs: "flex", sm: "flex", md: "flex" },
                  flexDirection: "column",
                  backgroundColor: "background.paper",
                  borderRight: { sm: "none", md: "1px solid" },
                  borderColor: { sm: "none", md: "divider" },
                  alignItems: "start",
                  pt: { xs: -4, md: 4 },
                  px: { xs: 1, sm: 3 },
                  gap: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    mt: { xs: 3, md: 15 },
                  }}
                >
                  <Button
                    startIcon={<Icon>arrow_back_rounded</Icon>}
                    sx={{ ml: "-8px" }}
                    onClick={() => {
                      window.history.back();
                    }}
                  >
                    Back
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    width: "100%",
                    // maxWidth: 500,
                  }}
                  mt={3}
                >
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      Total
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      <small>{currency}</small>
                      {(totalPrice / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </Box>
                  <Box mt={1}>
                    <Divider />
                  </Box>
                  {products.length > 0 ? (
                    <Box mt={2} mb={5}>
                      <List disablePadding>
                        {products.map((product) => (
                          <ListItem
                            key={product.reference}
                            sx={{ py: 1, px: 0 }}
                          >
                            <ListItemIcon>
                              <img
                                src={`${AppConfig.api_media_url}${product.image}`}
                                alt={product.name}
                                width="48px"
                              />
                            </ListItemIcon>
                            <ListItemText
                              sx={{ mr: 2 }}
                              primary={product.name}
                              secondary={
                                <Box mt={1}>
                                  <Typography fontSize={10}>
                                    {product.variants.map((variant) => (
                                      <>
                                        {variant.variant_title}
                                        :&nbsp;{variant.option_title}
                                        &nbsp;|&nbsp;
                                      </>
                                    ))}
                                    {`Quantity: ${product.quantity}`}
                                  </Typography>
                                </Box>
                              }
                            />
                            <Box>
                              <Box mt={1}>
                                <Typography variant="body1" fontWeight="medium">
                                  <small>{currency}</small>
                                  {(
                                    (product.amount * product.quantity) /
                                    100
                                  ).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </Box>
                              {/* <Box mt={-1} align="right">
                                <IconButton onClick={() => navigate("/ws/cart")}>
                                  <Icon color="">edit_note</Icon>
                                </IconButton>
                              </Box> */}
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  ) : (
                    <> </>
                  )}
                </Box>
              </Grid>
              <Grid
                item
                sm={12}
                md={7}
                lg={8}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: "100%",
                  width: "100%",
                  backgroundColor: {
                    xs: "transparent",
                    sm: "background.default",
                  },
                  alignItems: "start",
                  pt: { xs: 2, sm: 4 },
                  px: { sm: 10 },
                  gap: { xs: 4, md: 8 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: { sm: "space-between", md: "flex-end" },
                    alignItems: "center",
                    width: "100%",
                    maxWidth: { sm: "100%", md: 600 },
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                      flexGrow: 1,
                      height: 150,
                    }}
                  >
                    <Icon color="primary">receipt</Icon>
                    <Stepper
                      id="desktop-stepper"
                      activeStep={activeStep}
                      sx={{
                        width: "100%",
                        height: 40,
                      }}
                    >
                      {steps.map((label) => (
                        <Step
                          sx={{
                            ":first-child": { pl: 0 },
                            ":last-child": { pr: 0 },
                          }}
                          key={label}
                        >
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    width: "100%",
                    // maxWidth: { sm: "100%", md: 600 },
                    // maxHeight: "720px",
                    gap: { xs: 5, md: "none" },
                  }}
                >
                  <Stepper
                    id="mobile-stepper"
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{ display: { sm: "flex", md: "none" } }}
                  >
                    {steps.map((label) => (
                      <Step
                        sx={{
                          ":first-child": { pl: 0 },
                          ":last-child": { pr: 0 },
                          "& .MuiStepConnector-root": {
                            top: { xs: 6, sm: 12 },
                          },
                        }}
                        key={label}
                      >
                        <StepLabel
                          sx={{
                            ".MuiStepLabel-labelContainer": {
                              maxWidth: "70px",
                            },
                          }}
                        >
                          {label}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                  {activeStep === steps.length ? (
                    <Stack spacing={2} useFlexGap>
                      <Typography variant="h1">📦</Typography>
                      <Typography variant="h5">
                        Thank you for your order!
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        Your order number is
                        <strong>&nbsp;#140396</strong>. We have emailed your
                        order confirmation and will update you once its shipped.
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{
                          alignSelf: "start",
                          width: { xs: "100%", sm: "auto" },
                        }}
                      >
                        Go to my orders
                      </Button>
                    </Stack>
                  ) : (
                    <>
                      <Container>
                        {getStepContent(activeStep)}
                        <Box mt={10} mb={5}>
                          <Grid container spacing={3}>
                            <Grid item xs={6}>
                              <Box align="left">
                                {activeStep !== 0 && (
                                  <Button
                                    startIcon={<Icon>chevron_left</Icon>}
                                    onClick={handleBack}
                                    variant="outlined"
                                  >
                                    Previous
                                  </Button>
                                )}
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box align="right">
                                <Button
                                  xs={6}
                                  variant="contained"
                                  endIcon={
                                    <Icon>
                                      {activeStep === steps.length - 2
                                        ? "payment"
                                        : "chevron_right"}
                                    </Icon>
                                  }
                                  onClick={handleNext}
                                >
                                  {activeStep === steps.length - 2
                                    ? "Pay"
                                    : "Next"}
                                </Button>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Container>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default CheckoutPage;
